import * as yup from "yup";

// CZ: the premium (policy) expiry date is hidden and optional - the backend sets
// it 30 years after the valid-from date. It is shown (and mandatory) only for the
// one-time payment method, where the premium ends on its expiry date (max. one year).
export const isPremiumExpiryDateOptional = (countryCode?: string) =>
  countryCode === "Country.CZ";

export const getOneTimePaymentMethodId = (taxonomy: any): number | undefined =>
  taxonomy?.PaymentMethod?.byCode?.["PaymentMethod.ONE_TIME"]?.id;

// The payment method is a taxonomy option ({ value, label }) in the forms and
// its id in the premium data.
const isOneTimePaymentMethod = (
  paymentMethod: any,
  oneTimePaymentMethodId?: number
) =>
  oneTimePaymentMethodId != null &&
  (paymentMethod?.value ?? paymentMethod) === oneTimePaymentMethodId;

/** The expiry date is shown - and then always mandatory. */
export const isPremiumExpiryDateShown = (
  countryCode: string | undefined,
  paymentMethod: any,
  oneTimePaymentMethodId?: number
) =>
  !isPremiumExpiryDateOptional(countryCode) ||
  isOneTimePaymentMethod(paymentMethod, oneTimePaymentMethodId);

/**
 * `required` is the country-independent schema of the dialog; for CZ it only
 * applies with the one-time payment method, otherwise `optional` does.
 */
export const premiumExpiryDateSchema = (
  required: yup.AnySchema,
  optional: yup.AnySchema,
  countryCode: string | undefined,
  oneTimePaymentMethodId?: number
): yup.AnySchema =>
  isPremiumExpiryDateOptional(countryCode)
    ? yup.mixed().when("paymentMethod", {
        is: (paymentMethod) =>
          isOneTimePaymentMethod(paymentMethod, oneTimePaymentMethodId),
        then: required,
        otherwise: optional,
      })
    : required;
